__turbopack_context__.v({
  "inputRange": "inputRange-module-scss-module__fN73sW__inputRange",
  "isDisabled": "inputRange-module-scss-module__fN73sW__isDisabled",
});
